import { Component, Inject, OnInit } from '@angular/core';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { ModalNewSection, ModalUpdateSection } from '../../config-setup-inductionand-sections';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  typeid: number,
  edit: boolean,
  ID: number,
  InductionType: number,
  Name: string,
  Order: number,
  Active: boolean
}
@Component({
  selector: 'app-dialog-add-section',
  templateUrl: './dialog-add-section.component.html',
  styleUrls: ['./dialog-add-section.component.css']
})
export class DialogAddSectionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogAddSectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,
  ) { }

  Name: string = "";
  typeid: number;
  ngOnInit() {
    this.typeid = this.data.typeid;

    if(this.data.edit){
      this.Name=this.data.Name
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {
    if(this.data.edit){
    let params = new ModalUpdateSection();

    params.selectionId = this.data.ID;
    params.selectionName = this.Name;
    params.typeid = this.typeid
    params.active=this.data.Active;
    params.order=this.data.Order;
    

    //create new category
    this._inductionService.UpdateSection(params).subscribe(res => {
      console.log("CreateInductionSelections", res)
      if (res.m_Item1) {
        this.dialogRef.close(true);
      }
      // this.dialogRef.close();

    })
  }else{
    let params = new ModalNewSection();

    params.selectionName = this.Name;
    params.typeid = this.typeid

    //create new category
    this._inductionService.CreateInductionSelections(params).subscribe(res => {
      console.log("CreateInductionSelections", res)
      if (res.m_Item1) {
        this.dialogRef.close(true);
      }
      // this.dialogRef.close();

    })
  }
  }

}
